/** «Primeros pasos»: ruta elegida por empresa («sell» vender servicios digitales / «attention» atención y difusión). */
export const TRACK_EVENT = "gettingStartedTrack";
const keyOf = (companyId) => `gettingStartedTrack:${companyId || 0}`;

/** Con Negocio en el plan la ruta por defecto es vender; sin Negocio siempre atención. */
export function readTrack(companyId, hasNegocio) {
  if (!hasNegocio) return "attention";
  try {
    const saved = localStorage.getItem(keyOf(companyId));
    return saved === "attention" || saved === "sell" ? saved : "sell";
  } catch (_) {
    return "sell";
  }
}

export function saveTrack(companyId, track) {
  try { localStorage.setItem(keyOf(companyId), track); } catch (_) { /* sin almacenamiento */ }
  window.dispatchEvent(new CustomEvent(TRACK_EVENT, { detail: { companyId, track } }));
}

/** Pasos de la ruta de venta tal como los entrega el backend, con la forma de los pasos actuales. */
export const sellSteps = (rows) => (Array.isArray(rows) ? rows : []).map((row) => ({
  id: row.id, to: row.to, done: !!row.done, optional: !!row.optional,
  title: row.title, desc: row.desc, missing: row.missing || "", digi: row.digi || "",
}));

/** Video de Ayuda de un paso: el que tenga «#paso-<id>» en su descripción. */
export const stepVideo = (helps, stepId) =>
  (Array.isArray(helps) ? helps : []).find((h) => new RegExp(`#paso-${stepId}\\b`, "i").test(String(h?.description || ""))) || null;

export function videoUrl(help) {
  const video = String(help?.video || "").trim();
  if (/^[a-zA-Z0-9_-]{11}$/.test(video)) return `https://www.youtube.com/watch?v=${video}`;
  if (/^https?:\/\//i.test(video)) return video;
  return /^https?:\/\//i.test(String(help?.link || "")) ? help.link : null;
}

/** Abre Digi (botón flotante) y le pide guiar paso a paso. */
export const askDigi = (question) => window.dispatchEvent(new CustomEvent("digi:ask", { detail: { question, guided: true } }));
